
import React, {FC, MouseEvent, useState, useRef, useEffect, ChangeEvent, MutableRefObject}  from 'react';
import {useParams} from 'react-router';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import { Controller, FieldArray, FieldArrayMethodProps, FormProvider, useFieldArray, useForm } from 'react-hook-form';
import { StringIfPlural, useTranslation  } from 'react-i18next';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import { MdOutlineAdd } from 'react-icons/md';


import entityService, { useBasicFilterEntity } from 'features/services/Entity';
import { currentBasicTextFilterPropsAtom, currentFormNameAtom, isSearchBoxShowAtom, isSaveLoadingAtom } from 'library/store';
import useDeductionComponentService, { useBasicFilterDeductionComponent } from './services/DeductionComponent';
import { useRecoilState } from 'recoil';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { IEntity, IResult } from 'library/interface';
import Button from '@mui/material/Button';
import { Checkbox, FormControlLabel, IconButton, InputAdornment, MenuItem, Tabs, Tab, Typography, Chip, FormHelperText, Link } from '@mui/material';
import NumberFormat from 'react-number-format';

import { IDeductionComponent, _DeductionComponent, defaultDeductionComponent } from './models/DeductionComponent';


import TextFieldRight from 'components/ui/TextFieldRight';
import { FormDialog } from 'components/ui/FormDialog';
import { BasicTextFilterForm } from 'components/ui/BasicTextFilterForm';
import useEnumerationService, { useBasicFilterEnumeration, useEnumerationItemCreateUpdate } from 'features/configuration/services/Enumeration';


import IEnumeration,  { IEnumerationItem, Enum_DEDUCTION_COMPONENT_CATEGORY, Enum_RESOURCE_OPTION_CLASS } from 'features/configuration/models/Enumeration';
import {ITarification} from 'features/configuration/models/Tarification';


import { IExtensionType  } from 'features/configuration/models/ExtensionType';
import useExtensionTypeService, { useBasicFilterExtensionType } from 'features/configuration/services/ExtensionType';

import { carouselImage, justifyCenter, typographyGroupBoxStyling } from 'themes/commonStyles';

import EntityExpression from 'components/ui/EntityExpression';
import { isFalsy } from 'utility-types';
import ArrayFieldTableEx, { ActionIconTableRow, HeadCell } from 'components/ui/ArrayFieldTableEx';
import { DialogEnumerationItemForm } from 'features/configuration/DialogEnumerationItemForm';

export const DeductionComponentForm: FC<IDeductionComponent> = (props: IDeductionComponent = defaultDeductionComponent) => {

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();  
  const { enqueueSnackbar } = useSnackbar();

  const {id} = useParams();
  
  const [_id, _setId] = useState<number>( Number( id || 0 ) );

  const {retrieveEntity, retrieveData, openEntityActionDrawer, 
      checkEntityExpressionSyntax, checkEntitySaveAuthorization } = entityService();

  const {getEnumerationItemsByEnumerationCodes, getAsOptions } = useEnumerationService();


  const { createDeductionComponent, updateDeductionComponent } = useDeductionComponentService();

  const [currentFormName, setCurrentFormNameAtom] = useRecoilState(currentFormNameAtom);
  const [isSaveLoading, setIsSaveLoading] = useRecoilState(isSaveLoadingAtom);

  const [isSearchBoxShow, setIsSearchBoxShow] = useRecoilState(isSearchBoxShowAtom);
  const [currentBasicTextFilterProps, setCurrentBasicTextFilterProps] = useRecoilState(currentBasicTextFilterPropsAtom);
  const basicFilterDeductionComponent = useBasicFilterDeductionComponent( 0,
    (event: React.MouseEvent<unknown>, row: IDeductionComponent) => {
        setIsSearchBoxShow(false);
        _setId(row.id);
      }
  );

  const emptyFunc = (obj: any) => {}

  const {canAddEnumerationItem, canUpdateEnumerationItem, displayEnumerationItemDialog,
    enumerationItem, hideEnumerationItemDialog, saveEnumerationItem,
    onAddItemClick, onUpdateItemClick } = useEnumerationItemCreateUpdate();
  
  const [openEntityFilter, setOpenEntityFilter] = useState(false);
  const basicFilterEntity = useBasicFilterEntity( 
      (event: React.MouseEvent<unknown>, row: IEntity) => {
          const {name, description} = row;

          // setValue('entityName', name || '');
          // setValue('entityDescription', description || '');
                           
          setOpenEntityFilter(false);
      }
  );

  const [openEnumerationFilter, setOpenEnumerationFilter] = useState(false);
  const basicFilterEnumeration = useBasicFilterEnumeration( 
      (event: React.MouseEvent<unknown>, row: IEnumeration) => {
          const {id, name, description} = row;

          // setValue('enumerationId', id);
          // setValue('enumerationName', name);
                           
          setOpenEnumerationFilter(false);
      }
  );
  

  
  const methods = useForm<IDeductionComponent>({defaultValues:defaultDeductionComponent});
  const { register, setValue ,getValues, watch, reset ,handleSubmit ,control , formState: { errors } } = methods;

  const watchDeductionComponent = watch('type');
  
  // const watchFileName = watch('fileName');
  // const watchBase64Picture = watch('base64Picture');
   // let { fields, append: appendCoverages, update: updateCoverage ,remove: removeCoverage,  } = useFieldArray({//<O, TName>({ //<O,`billingDetails.${number}.billingDetailTasks`>({
  //   name: `productCoverages`,
  //   control,            
  // });
  

  const queryClient = useQueryClient();
  const {isLoading, isError, isSuccess ,error,mutate } = useMutation<IResult<IDeductionComponent>,Error,IDeductionComponent>(
      _id>0?updateDeductionComponent:createDeductionComponent, {   
        onSuccess: (data: IResult<IDeductionComponent>) => {
          enqueueSnackbar( t('_Operation_done'), { variant: 'success',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1000 }); 
                   
          setIsSaveLoading(false);
          _setId(data.data.id);
          //setCurrentEntityIdForAction(data.data.id);
          setCurrentFormNameAtom(`${t('DeductionComponent')} - # ${data.data.id} # ` );
          //queryClient.invalidateQueries(['DeductionComponent',data.data.id]);
        },
        onError: (err: Error) => {          
          enqueueSnackbar( error?.message, { variant: 'error',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
          setIsSaveLoading(false);
        }
      });

    const {data: _data, refetch} = useQuery<IDeductionComponent>(['DeductionComponent', _id], () => retrieveEntity('DeductionComponent',_id), 
      {refetchOnWindowFocus: false ,enabled: false } );

    const {data: enumItems, refetch: refetchEnumerationItems} = useQuery<IEnumerationItem[]>( ['EnumerationItems', 'DeductionComponent'], () => getEnumerationItemsByEnumerationCodes
      ( [Enum_DEDUCTION_COMPONENT_CATEGORY ] ));

    const [valueTabCoverage, setValueTabCoverage] = useState<number>(0);

    const handleTabCoverageChange = (event: React.SyntheticEvent, newValue: number) => {  
       setValueTabCoverage(newValue);       
    };
      
    const handleDeductionComponent = ( event: React.MouseEvent<HTMLElement>, _newDeductionComponent: _DeductionComponent ) => {

      if(_newDeductionComponent === null) return;
      setValue('type', _newDeductionComponent);

    };

   const [openEntityExpression, setOpenEntityExpression] = useState(false);
         const [currentExpression, setCurrentExpression] = useState(''); 
         const [currentEntityName, setCurrentEntityName] = useState(''); 
         const [currentReturnType, setCurrentReturnType] = useState(''); 
   
         type ExpressionType = 'payroll-deduction' ;
         const [currentExpressionType, setCurrentExpressionType] = useState<ExpressionType>('payroll-deduction');
   
         const handleClickOpenExpression = (event: any, expressionType: ExpressionType, 
             entityName: string, returnType: string, expression: string) => {
   
           setCurrentExpressionType(expressionType);
           setCurrentEntityName(entityName);
           setCurrentReturnType(returnType);
           setCurrentExpression(expression);
           setOpenEntityExpression(true);
         }
   
         const handleClickOkExpression = async () => {
           const checkExpression = await checkEntityExpressionSyntax(currentEntityName, currentExpression);
           if(!checkExpression){
             enqueueSnackbar( t('Expression evaluation error'), { variant: 'error',
                   anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
             return;
           }
   
           const {syntaxOk, syntaxError, returnType} = checkExpression;
           if(!syntaxOk) {
             enqueueSnackbar( syntaxError , { variant: 'error',
                   anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
             return;
           }
          
           if(returnType !== currentReturnType) {
             enqueueSnackbar( `${t('The result of expression must be')} ${currentReturnType}` , { variant: 'error',
                   anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
                   return;
           }
   
          if(['payroll-deduction'].includes(currentExpressionType) ) {
               setValue('amountExpression', currentExpression);
           }
   
           setOpenEntityExpression(false);
         }

    

  const refEnumItems = useRef<IEnumerationItem[]>();    
  useEffect( () => {   
      refEnumItems.current = enumItems;
    
  }, [enumItems])


      useEffect( () => {        
        setCurrentFormNameAtom(t('DeductionComponent'));
        setCurrentBasicTextFilterProps(basicFilterDeductionComponent);
      }, []);    
    
      /********** This use effect call retreive data wich will call refetch and _data will be updated. 
        and the new useEffect will take place ********************/
        useEffect( () => {
            // setCurrentFormName(t('Billing'));        
            
            if(_id > 0)
              retrieveData('DeductionComponent',_id, refetch);  
          }, [_id] );
    
    
        useEffect( () => {
            
        if(_data && _data.id > 0) {
            setCurrentFormNameAtom(`${t('DeductionComponent')} - # ${_data.id} #` );
            reset(_data);
        }
        }, [_data]);
    
      const newData = async (event: MouseEvent<HTMLButtonElement>) => {    
        _setId(0);      
        reset(defaultDeductionComponent);    
      }
      
      const saveData = async (event: MouseEvent<HTMLButtonElement>) => {     
        
        if(!checkEntitySaveAuthorization('DeductionComponent', _id)) {
          setIsSaveLoading(false);
             return;
        }
        const data = getValues(); 

        if(data.name.trim() === '' || data.description.trim() === '') {
          enqueueSnackbar( t('Reference is not specified'), { variant: 'warning',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1500 }); 
                setIsSaveLoading(false);
                return;
        }
        
          mutate(data);
      }
    
      const actionData = async (event: MouseEvent<HTMLButtonElement>) => {
        openEntityActionDrawer('DeductionComponent', _id);
      }
      
    const afterAction = async (event: MouseEvent<HTMLButtonElement>) => {          
    //    queryClient.invalidateQueries(['RequestType',currentEntityIdForAction]);        
    //    await retreiveData(currentEntityNameForAction,currentEntityIdForAction, refetch);        
    //    reset(_data);        
    }

  return (
    <FormProvider {...methods} >
            <Box sx={{ mx: 0.1 }}>
                <Grid container rowSpacing={0.5} columnSpacing={0.1}>
                    <Grid item xs={12} md={6} lg={6} component={Paper} sx={{ borderRadius: 2, ml: 0, }} >                        
                        <Stack flexDirection='column'  >
                            <Box sx={{ mt: 1, width: '100%' }} >
                                <Button id='btnNew' onClick={newData} sx={ {display:'none'}}  />                                  
                                <Button id='btnSave' onClick={saveData} sx={ {display:'none'}}  />
                                <Button id='btnAction' onClick={actionData} sx={ {display:'none'}}  />                                                              
                                <Button id='btnAfterAction' onClick={afterAction} sx={ {display:'none'}}  />
                                <TextField sx={{width:'calc(20% - 8px)'}} id="id" label={t('Code')} {...register('code')} inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } } /> 
                                <TextField sx={{width:'calc(60% - 8px)'}} id="name" label={t('Name')} {...register('name')} inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } } />                                
                                <FormControlLabel sx={{width:'calc(20% - 8px)'}}
                                    label={`${t('Active ?')}`}
                                    control={
                                    <Controller
                                        name='isActive'
                                        control={control}
                                        render={({field: {value, onChange,...props} }) => <Checkbox {...props} checked={value} onChange={onChange} />}                        
                                />} />
                            </Box>
                            <Box sx={{ mt: 1, width: '100%' }} >
                              <ToggleButtonGroup value={watchDeductionComponent} exclusive key={watchDeductionComponent} size="small" onChange={handleDeductionComponent} aria-label="text alignment" fullWidth >
                                <ToggleButton value="employee" aria-label="centered">
                                  {t('Employee')}
                                </ToggleButton>
                                <ToggleButton value="allowance" aria-label="centered">
                                  {t('Employer')}
                                </ToggleButton>   
                              </ToggleButtonGroup>                                                             
                            </Box>   
                                                                               
                            <Box sx={{ mt: 1, width: '100%' }} >
                              <TextField sx={{width:'calc(100% - 8px)'}} id="description" label={t('Description')} {...register('description')} />                                                              
                            </Box>
                            <Box sx={{ mt: 1, width: '100%' }} >
                              <Controller name='category' control={control}                                     
                                  render={ ({field: {onChange, value}}) => (
                                    <TextField select onChange={onChange} value={value} sx={{width:'calc(50% - 8px)'}} id="category"
                                      label={t('Category')} inputProps={ {readOnly: false}} focused >
                                      {enumItems && enumItems.filter( e => 
                                            e.enumerationCode === Enum_DEDUCTION_COMPONENT_CATEGORY ).map( 
                                        (x,idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem> )
                                      }
                                    </TextField>
                                  )}
                              />                               
                            </Box>
                            <Box sx={{ mt: 1, width: '100%' }} >
                              <Controller
                                    key={`payroll-deduction`}
                                    render={({ field }) => <TextField label={`${t('Amount')} - ${t('Expression')}`} multiline rows={2}
                                        {...field} inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } }
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton color="primary" onClick={(event) => handleClickOpenExpression(event, 'payroll-deduction', 'Payroll', 'numeric', getValues().expressionAmount)}>
                                                  <DeveloperModeIcon />
                                                </IconButton>                                                                              
                                            </InputAdornment>
                                        )
                                      }}
                                      sx={{width:`calc(100% - 8px)`, textTransform: 'none'}}  />} 
                                      name={`amountExpression`}                      
                                    control={control}
                                  />                                                                                          
                            </Box>
                            { openEntityExpression && <FormDialog open={openEntityExpression} maxWidth='md'
                                  okText={t('OK')} cancelText='' title={t('Expression')} onCancel={()=> {}} 
                                  onClose={()=> {setOpenEntityExpression(false);}} onOk={handleClickOkExpression}  >
                                  <EntityExpression entityName={currentEntityName} properties={[]} 
                                    expression={currentExpression} setExpression={setCurrentExpression} />
                                </FormDialog>  }
                            { displayEnumerationItemDialog && <DialogEnumerationItemForm 
                              {...{open: displayEnumerationItemDialog, 
                                    title: '', 
                                    enumerationItem, hideEnumerationItemDialog, saveEnumerationItem,
                                    afterSave: async () => {await refetchEnumerationItems()}}} 
                              />
                          }
                        </Stack>                        
                      </Grid>
                    <Grid item xs={12} md={6} component={Paper} sx={{ borderRadius: 2, ml: 0, }} >
                      <Stack flexDirection='column'>
                        <Box key={` - key`} sx={{ mt: 1, width: '100%' }} >  
                          
                        </Box>                        
                      </Stack>
                    </Grid>     
                                                  
                </Grid>
            </Box>
        </FormProvider> 
  )
}

